import { useStore } from '@nanostores/react';
import { ClientOnly } from 'remix-utils/client-only';
import { AuthButtons } from './AuthButtons';
import { BaseHeader } from './BaseHeader';
import { HeaderSocialLinks } from './HeaderSocialLinks';
import { MobileMainMenu } from './MobileMainMenu';
import { Navbar } from './Navbar';
import { ProjectHeader } from './ProjectHeader';
import { chatStore } from '~/lib/stores/chat';
import { userStore } from '~/lib/stores/user';

/**
 * TODO: Split the header into two separate components as the one used in
 * chats will soon be considerably different from the one used on homepage
 * and other screens. Currently, we're using `chatStarted` to work out
 * which bits to show/hide.
 * I think we may also need a new layout as the chat page layout will differ
 * significantly from the homepage layout.
 * For now the feature flag is used along with `chatStarted` to work out that
 * we're in a chat and therefore show the new header.
 *
 * See https://linear.app/stackblitz/issue/BOU-226.
 */
export function Header() {
  const chatStarted = useStore(chatStore.started);
  return chatStarted ? <ProjectHeader /> : <OldHeader />;
}

type OldHeaderProps = {};

function OldHeader({}: OldHeaderProps) {
  const loggedIn = useStore(userStore.loggedIn);

  return (
    <BaseHeader border>
      <ClientOnly>{() => <Navbar className="hidden lg:flex" />}</ClientOnly>
      <div className="flex grow-1 basis-60 justify-end items-center gap-3">
        <ClientOnly>
          {() => (
            <>
              <HeaderSocialLinks />

              {!loggedIn && <AuthButtons className="hidden lg:flex" />}

              <MobileMainMenu />
            </>
          )}
        </ClientOnly>
      </div>
    </BaseHeader>
  );
}
